// ** React Imports
import { useState, useEffect, SyntheticEvent, useRef } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Fab,
    Autocomplete,
    InputLabel,
    Select,
    MenuItem,
    Tooltip,
} from '@mui/material'
import { useParams } from "react-router-dom";
import { Controller, set, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import appInfo from '../../../../configs/app-info';
import { useToast } from '../../../../components/ToastProvider';
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { tab } from '@testing-library/user-event/dist/tab';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();
    
    const [valGudang, setValGudang] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])
    const [listSubGudang, setListSubGudang] = useState<any[]>([])
    const [listBahanBaku, setListBahanBaku] = useState<any[]>([])
    const [listBarangJadi, setListBarangJadi] = useState<any[]>([])
    const [valBarang, setValBarang] = useState<any>(null)
    const [isBatch, setIsBatch] = useState<any>(false)
    const [isEdit, setIsEdit] = useState<any>(false)
    const [batch, setBatch] = useState<any>('')
    const [tabs, setTabs] = useState<string>("0")
    const [tabsDetail, setTabsDetail] = useState<string>("0")

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])
    const [listDetail, setListDetail] = useState<any[]>([])
    const [listBiaya, setListBiaya] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogBiaya, setOpenDialogBiaya] = useState<boolean>(false)
    const { showToast, hideToast } = useToast();
    const inputRef = useRef<HTMLInputElement>(null)


    useEffect(() => {
        getData()
        getDetail(tabs)
        getBarang(0)
        setValue('mmreclass_id', id)
    }, [])

    const InfoItem = ({ label, value }: { label: string; value: string | number }) => (
        <Box sx={{ mb: 1.5 }}>
            <Typography
                sx={{ fontSize: 13, fontWeight: 600, color: "text.secondary", mb: 0.3 }}
            >
                {label}
            </Typography>
            <Typography>
                {value || "-"}
            </Typography>
        </Box>
    );
    
    const getDoctag = (ids: any) => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
        .get(url, {
            params: {sysmenu_id: appInfo.menuId.reclass},
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
            if (response.data.success) {
                const data = response.data.data
                data.forEach((element: any) => {
                if (element.id === ids) {
                    setValDoctag(element)
                    setValue('sysdoctag_id', element.id)
                }
            });
                setListDoctag(data)
            } else {
                showToast(response.data.message, 'error' )
            }
        })
    }
    const getBarang = (tab:any) => {
        let url = "";
        if(tab == "0"){
            url = apiUrl.apiUrl + '/mm/barang/list-combo-barang-jadi';
        }else{
            url = apiUrl.apiUrl + '/mm/barang/list-combo-bahan-baku';
        }
        axios
        .get(url, {
            params: {sysmenu_id: appInfo.menuId.usage},
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
            if (response.data.success) {
                const data = response.data.data
                if(tabs == "0"){
                    setListBarangJadi(data);
                }else{
                    setListBahanBaku(data);
                }
            } else {
                showToast(response.data.message, 'error' )
            }
        })
    }

    const getGudang = (ids: any) => {
        const url = apiUrl.apiUrl + '/mm/gudang/list-combo-gudang-jadi'
        axios
        .get(url, {
            params: {},
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
            if (response.data.success) {
                const data = response.data.data
                data.forEach((element: any) => {
                if (element.id === ids) {
                    setValGudang(element)
                    setValue('mmgudang_id', element.id)
                }
            });
                setListGudang(data)
            } else {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: response.data.message,
                    icon: 'error'
                })
            }
        })
    }
    
    const getSubGudang = (gudangId: any) => {
        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'
        axios
        .get(url, {
            params: {mmgudang_id: gudangId},
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
            if (response.data.success) {
                const data = response.data.data
                setListSubGudang(data)
            } else {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: response.data.message,
                    icon: 'error'
                })
            }
        })
    }
    const getDetail = (tab: string) => {
        const url = apiUrl.apiUrl + '/production/bhp/detail-item/' + id +'/'+ tab
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListDetail(response.data.data)
                } else {
                    showToast(response.data.message, 'error' )
                }
            })
            .catch(error => {
                showToast(error.message, 'error' )
            })
    }

    const getBiaya = () => {
        const url = apiUrl.apiUrl + '/production/bhp/detail-biaya/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListBiaya(response.data.data)
                } else {
                    showToast(response.data.message, 'error' )
                }
            })
            .catch(error => {
                showToast(error.message, 'error' )
            })
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        if(newValue == "0" || newValue == "1"){
            getDetail(newValue)
            getBarang(newValue);
        }else{
            getBiaya()
        }
    }

    const ActionButtons = ({ row, onDelete }: { 
        row: any; 
        onDelete: (row: any) => void; 
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => {
                    axios
                        .get(`${apiUrl.apiUrl}/production/bhp/item-detail/${row.id}`, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                const data = response.data.data;
                                setOpenDialog(true);
                                resetDetail();
                                setIsEdit(true);
                                if(data.mmbarang_batch_id != null){
                                    setIsBatch(true);
                                    setBatch(data.mmbarang_batch_id);
                                    setValue('mmbarang_batch_id', data.mmbarang_batch_id);
                                } else {
                                    setIsBatch(false);
                                    setBatch('');
                                    setValue('mmbarang_batch_id', '');
                                }
                                let isBaku = tabs === "0" ? 1 : 0;
                                setValue('mmreclass_d_id', data.id);
                                setValBarang(response.data.barang);
                                setValue('mmbarang_id', data.mmbarang_id);
                                setValue('qty', isBaku ? data.qty*-1 : data.qty);
                                setValue('mmgudang_sub_id', data.mmgudang_sub_id);
                                setValue('keterangan_detail', data.keterangan);
                                
                            } else {
                                showToast(response.data.message, 'error');
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                }
            },
            {
                title: "Hapus BHP", 
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };
    const ActionButtonBiaya = ({ row, onDelete }: { 
        row: any; 
        onDelete: (row: any) => void; 
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => {
                    axios
                        .get(`${apiUrl.apiUrl}/production/bhp/biaya-detail/${row.id}`, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                const data = response.data.data;
                                setOpenDialogBiaya(true);
                                resetDetail();
                                setIsEdit(true);
                                setValue('mmreclass_d_id', data.id);
                                setValue('total_biaya', data.total);
                                setValue('keterangan_detail', data.keterangan);
                                
                            } else {
                                showToast(response.data.message, 'error');
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                }
            },
            {
                title: "Hapus BHP", 
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons 
                    row={row} 
                    onDelete={() => {
                        axios
                            .delete(`${apiUrl.apiUrl}/production/bhp/delete-item/${row.id}`, {
                                headers: { Authorization: `Bearer ${token}` }
                            })
                            .then(response => {
                                Swal.close()
                                if (response.data.success) {
                                    showToast(response.data.message, 'success')
                                    getDetail(tabs)
                                } else {
                                    showToast(response.data.message, 'error')
                                }
                            })
                            .catch(error => {
                                showToast(error.message, 'error')
                            })
                    }}
                />
            ),
        },
    ];
    
    const actionBiaya = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box
                    sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                    }}
                >
                    <ActionButtonBiaya 
                        row={row} 
                        onDelete={() => {
                            axios
                                .delete(`${apiUrl.apiUrl}/production/bhp/delete-biaya/${row.id}`, {
                                    headers: { Authorization: `Bearer ${token}` }
                                })
                                .then(response => {
                                    Swal.close()
                                    if (response.data.success) {
                                        showToast(response.data.message, 'success')
                                        getBiaya()
                                    } else {
                                        showToast(response.data.message, 'error')
                                    }
                                })
                                .catch(error => {
                                    showToast(error.message, 'error')
                                })
                        }}
                    />

                </Box>
            ),
        },
    ];

    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_id', newValue ? newValue.id : null)
        setValGudang(newValue.nama )
    }
    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/production/bhp/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    const wo = response.data.work_order
                    console.log(wo);
                    setValue('syscabang_id', data.syscabang_id)
                    setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('mmgudang_id', data.mmgudang_id)
                    setValue('tgl', data.tgl)
                    setValue('keterangan', data.keterangan)
                    setValue('pic', data.pic)

                    setValue('work_order', wo.id ? wo.id : '')
                    setValue('jenis', wo.jenis ? wo.jenis : '')
                    setValue('product', wo.product ? wo.product : '')
                    setValue('barang', wo.barang ? wo.barang : '')
                    setValue('qty_wo', wo.qty ? wo.qty : '')
                    setValue('satuan_wo', wo.satuan ? wo.satuan : '')
                    setValue('proses_wo', wo.proses ? wo.proses : '')
                    setValue('notes_wo', wo.notes ? wo.notes : '')

                    getDoctag(data.sysdoctag_id)
                    getGudang(data.mmgudang_id)
                    getSubGudang(data.mmgudang_id)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }
    interface FormInputs {
        mmreclass_id: any,
        syscabang_id: any,
        sysdoctag_id: any,
        mmgudang_id: any,
        tgl: any,
        keterangan: any,
        pic: any,
        mmgudang_sub_id: any,
        mmbarang_id: any,
        qty: any,
        keterangan_detail: any,
        mmbarang_batch_id: any,
        mmreclass_d_id: any,
        is_baku: any,
        total_biaya: any,
        work_order: any,
        product: any,
        jenis: any,
        barang: any,
        qty_wo: any,
        satuan_wo: any,
        proses_wo: any,
        notes_wo: any,
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const resetDetail = () => {
        setValue('mmgudang_sub_id', '')
        setValue('mmbarang_id', '')
        setValue('qty', '')
        setValue('keterangan_detail', '')
        setValBarang(null)
        setValue('mmreclass_d_id', '')
        setValue('mmbarang_batch_id', '')
        setValue('total_biaya', '')
    }

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const onSubmit = (data: any) => {
        const url = apiUrl.apiUrl + '/production/bhp/edit/' + id
        axios
            .post(url, data, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success' )
                } else {
                    showToast(response.data.message, 'error' )
                }
            })
            .catch(error => {
                showToast(error.message, 'error' )
            })
    }
    const handleChangeAutocompleteBarang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmbarang_id', newValue?.id)
        setValBarang(newValue ? newValue : null)
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail BHP
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <br />
                    <Divider sx={{ mt: 0, mb: 3 }} />
                    <TabContext value={tabsDetail}>
                        <TabList
                            onChange={(event, newValue) => setTabsDetail(newValue)}
                            scrollButtons
                        >
                            <Tab value='0' label='DETAIL BHP' />
                            <Tab value='1' label='DETAIL WORK ORDER' />
                        </TabList>
                        <TabPanel value='0'>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth>
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='doctag'
                                                disabled
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                getOptionLabel={(option: any) => option.nama || ''}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                        label='Document'
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth>
                                            <Autocomplete
                                                value={valGudang}
                                                options={listGudang}
                                                id='gudang'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteGudang}
                                                getOptionLabel={(option: any) => option.nama || ''}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                        label='Gudang'
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='tgl'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        type='datetime-local'
                                                        value={value}
                                                        label='Tanggal'
                                                        onChange={onChange}
                                                        InputLabelProps={{ shrink: true }}
                                                        error={Boolean(errors.tgl)}
                                                    />
                                                )}
                                            />
                                            {errors.tgl && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='pic'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        value={value}
                                                        label='PIC'
                                                        InputLabelProps={{ shrink: true }}
                                                        onChange={onChange}
                                                        error={Boolean(errors.pic)}
                                                    />
                                                )}
                                            />
                                            {errors.pic && (
                                                <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='keterangan'
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        value={value}
                                                        label='Keterangan'
                                                        onChange={onChange}
                                                        multiline
                                                        InputLabelProps={{ shrink: true }}
                                                        rows={4}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4, mb: 4 }}>
                                                <Button variant='contained' type='submit'
                                                >
                                                    SIMPAN
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </form>
                        </TabPanel>
                        <TabPanel value='1'>
                            <form>
                                <Grid container spacing={2} sx={{ ml: 3 }}>
                                    <Grid item xs={12} md={6}>
                                        <InfoItem label="ID Work Order" value={watch("work_order")} />
                                    </Grid>
        
                                    <Grid item xs={12} md={6}>
                                        <InfoItem label="Jenis Product" value={watch("jenis")} />
                                    </Grid>
        
                                    <Grid item xs={12} md={6}>
                                        <InfoItem label="Product" value={watch("product")} />
                                    </Grid>
        
                                    <Grid item xs={12} md={6}>
                                        <InfoItem label="Barang" value={watch("barang")} />
                                    </Grid>
        
                                    <Grid item xs={12} md={6}>
                                        <InfoItem label="Qty" value={watch("qty_wo") ? watch("qty_wo") + " " + watch("satuan_wo") : "-"} />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <InfoItem label="Proses" value={watch("proses_wo") ? watch("proses_wo") : "-"} />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <InfoItem label="Keterangan" value={watch("notes_wo") ? watch("notes_wo") : "-"} />
                                    </Grid>
                                </Grid>
                            </form>
                        </TabPanel>
                    </TabContext>
                        
                    <Divider sx={{ m: 0 }} />
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='BARANG JADI' />
                            <Tab value='1' label='BAHAN BAKU TAMBAHAN' />
                            <Tab value='2' label='BIAYA' />
                        </TabList>
                        <TabPanel value='0'>
                            <Box sx={{ mt: 4 }}>
                                <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
                                    <Grid item xs={12} sm={8}></Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            fullWidth
                                            onClick={() => {
                                                setIsEdit(false);
                                                setIsBatch(false);
                                                setOpenDialog(true);
                                                resetDetail();
                                            }}
                                        >
                                            Tambah Barang Jadi
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Typography variant="h6" sx={{ mb: 2,textAlign: 'center' }}>
                                    LIST BARANG JADI
                                </Typography>
                                <Box sx={{ overflowX: 'auto' }}>
                                    <MsiDatagrid key={1} array={listDetail} actions={actionData} />
                                </Box>
                            </Box>
                        </TabPanel>
                        <TabPanel value='1'>
                            <Box sx={{ mt: 4 }}>
                                <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
                                    
                                    <Grid item xs={12} sm={8}></Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            fullWidth
                                            onClick={() => {
                                                setIsEdit(false);
                                                setIsBatch(false);
                                                setOpenDialog(true);
                                                resetDetail();
                                            }}
                                        >
                                            Tambah Bahan Baku
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Typography variant="h6" sx={{ mb: 2,textAlign: 'center' }}>
                                    LIST BAHAN BAKU
                                </Typography>
                                <Box sx={{ overflowX: 'auto' }}>
                                    <MsiDatagrid key={1} array={listDetail} actions={actionData} />
                                </Box>
                            </Box>
                        </TabPanel>
                        <TabPanel value='2'>
                            <Box sx={{ mt: 4 }}>
                                <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
                                    <Grid item xs={12} sm={10}></Grid>
                                    <Grid item xs={12} sm={2}>
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            fullWidth
                                            onClick={() => {
                                                setIsEdit(false);
                                                setOpenDialogBiaya(true);
                                                resetDetail();
                                            }}
                                        >
                                            Tambah Biaya
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Typography variant="h6" sx={{ mb: 2,textAlign: 'center' }}>
                                    LIST BIAYA
                                </Typography>
                                <Box sx={{ overflowX: 'auto' }}>
                                    <MsiDatagrid key={1} array={listBiaya} actions={actionBiaya} />
                                </Box>
                            </Box>
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
            <Dialog
                maxWidth={'md'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
            >
                <form onSubmit={handleSubmit((data) => {
                    setOpenDialog(false)
                    if(isBatch){
                        data.mmbarang_batch_id = batch;
                    }
                    data.is_baku = tabs === "0" ? 0 : 1;

                    let url = '';
                    if(isEdit){
                        url = apiUrl.apiUrl + '/production/bhp/edit-item/' + data.mmreclass_d_id
                    } else {
                        url = apiUrl.apiUrl + '/production/bhp/add-item'
                    }
                    axios
                        .post(url, data, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message,'success');
                                getDetail(tabs); // ✅ refresh data
                                setOpenDialog(false); // ✅ tutup setelah sukses
                                Swal.close();
                            } else {
                                showToast(response.data.message,'error');
                                Swal.close();
                            }
                        })
                        .catch(error => {
                            showToast(error.message,'error');
                            Swal.close();
                        })
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Item
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            {isBatch ? 
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Batch ID
                                </Typography>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Batch ID'
                                        value={batch}
                                        InputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            : null }
                            <Grid item xs={12} sm={isBatch ? 6 : 12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Barang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmbarang_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valBarang}
                                                options={tabs =="0" ? listBarangJadi:listBahanBaku}
                                                id='mmbarang_id'
                                                readOnly={isBatch ? true : false}
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteBarang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        error={Boolean(errors.mmbarang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmbarang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Qty
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qty'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Qty'
                                                error={Boolean(errors.qty)}
                                                onChange={onChange}
                                                value={value}
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Sub Gudang
                                </Typography>
                                <FormControl fullWidth>
                                    <InputLabel>Sub Gudang</InputLabel>
                                    <Controller
                                        name='mmgudang_sub_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Sub Gudang'
                                                value={value || ''}
                                                onChange={e => {
                                                    onChange(e);
                                                    setValue('mmgudang_sub_id', e.target.value);
                                                }}
                                                error={Boolean(errors.mmgudang_sub_id)}
                                            >
                                                {listSubGudang.map((item: any, index: any) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmgudang_sub_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_detail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                InputLabelProps={{ shrink: true }}
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'md'}
                fullWidth={true}
                open={openDialogBiaya}
                onClose={() => setOpenDialogBiaya(false)}
            >
                <form onSubmit={handleSubmit((data) => {
                    setOpenDialogBiaya(false);
                    let url = '';
                    if(isEdit){
                        url = apiUrl.apiUrl + '/production/bhp/edit-biaya/' + data.mmreclass_d_id
                    } else {
                        url = apiUrl.apiUrl + '/production/bhp/add-biaya'
                    }
                    axios
                        .post(url, data, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message,'success');
                                getBiaya(); // ✅ refresh data
                                setOpenDialogBiaya(false); // ✅ tutup setelah sukses
                                Swal.close();
                            } else {
                                showToast(response.data.message,'error');
                                Swal.close();
                            }
                        })
                        .catch(error => {
                            showToast(error.message,'error');
                            Swal.close();
                        })
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Biaya
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Total Biaya
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='total_biaya'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Total Biaya'
                                                error={Boolean(errors.total_biaya)}
                                                onChange={(e) => {
                                                    // Remove all non-digit characters
                                                    const numericValue = e.target.value.replace(/\D/g, '');
                                                    // Format with thousand separator
                                                    const formattedValue = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                    // Update the displayed value
                                                    e.target.value = formattedValue;
                                                    // Store the numeric value in form
                                                    onChange(numericValue);
                                                }}
                                                value={value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.total_biaya && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_detail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                InputLabelProps={{ shrink: true }}
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogBiaya(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid >
    )
}
